// app/javascript/modules/modal.js

var pendingElement = null;

function getOverlay() { return document.getElementById('modal-overlay'); }
function getTitleEl() { return document.getElementById('modal-title'); }
function getBodyEl() { return document.getElementById('modal-body'); }
function getConfirmBtn() { return document.getElementById('modal-confirm'); }
function getCancelBtn() { return document.getElementById('modal-cancel'); }
function getCloseBtn() { return document.getElementById('modal-close'); }

function openModal(message, options) {
  var overlay = getOverlay();
  var titleEl = getTitleEl();
  var bodyEl = getBodyEl();
  var confirmBtn = getConfirmBtn();
  if (!overlay) return;

  options = options || {};
  if (titleEl) titleEl.textContent = options.title || '操作确认';
  if (bodyEl) bodyEl.innerHTML = message;

  if (confirmBtn) {
    confirmBtn.className = options.danger ? 'btn-danger' : 'btn-primary';
    confirmBtn.textContent = options.confirmText || '确定';
  }

  overlay.classList.add('modal-open');
}

function closeModal() {
  var overlay = getOverlay();
  if (overlay) overlay.classList.remove('modal-open');
  pendingElement = null;
}

function handleEsc(e) {
  var overlay = getOverlay();
  if (e.key === 'Escape' && overlay && overlay.classList.contains('modal-open')) {
    closeModal();
  }
}

function initModal() {
  var overlay = getOverlay();
  var confirmBtn = getConfirmBtn();
  var cancelBtn = getCancelBtn();
  var closeBtn = getCloseBtn();

  if (!overlay) return;

  // Confirm button
  if (confirmBtn && confirmBtn.dataset.modalBound !== 'true') {
    confirmBtn.dataset.modalBound = 'true';
    confirmBtn.addEventListener('click', function() {
      var element = pendingElement;
      closeModal();

      if (element) {
        var confirmMsg = element.getAttribute('data-confirm');
        element.removeAttribute('data-confirm');
        element.click();
        if (confirmMsg) {
          element.setAttribute('data-confirm', confirmMsg);
        }
      }
    });
  }

  // Cancel/close buttons
  [cancelBtn, closeBtn].forEach(function(btn) {
    if (btn && btn.dataset.modalBound !== 'true') {
      btn.dataset.modalBound = 'true';
      btn.addEventListener('click', closeModal);
    }
  });

  // Click overlay to close
  if (overlay.dataset.modalBound !== 'true') {
    overlay.dataset.modalBound = 'true';
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
  }
}

// --- Override Rails.confirm (bound once) ---
if (window.Rails && !window.Rails._confirmOverridden) {
  window.Rails._confirmOverridden = true;
  window.Rails.confirm = function(message, element) {
    var isDanger = element.classList.contains('action-link-danger')
      || element.classList.contains('btn-danger')
      || element.classList.contains('text-danger');

    pendingElement = element;

    openModal(message, {
      danger: isDanger,
      confirmText: isDanger ? '确认删除' : '确定'
    });

    return false;
  };
}

if (!document._modalEscBound) {
  document._modalEscBound = true;
  document.addEventListener('keydown', handleEsc);
}

document.addEventListener('turbolinks:load', initModal);
